export const MODIFY_IMPORTER_NAME = 'MODIFY_IMPORTER_NAME';

export function modifyImporterName(importerName){
    return{
        type: MODIFY_IMPORTER_NAME,
        mainState: {
            importerName: importerName
        }
    }
}